import AppIcon from 'components/common/AppIcon/AppIcon';
import { rgba } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { colors, containerStyles } from 'styles/shared';



const InfoContainer = styled.div`
  width: 24.7rem;
  height: 23rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3.5rem 0.5rem 2.7rem;
  margin-right: 5rem;
  margin-bottom: 5rem;
  ${containerStyles};
`;

const IconContainer = styled.div`
  width: 5rem;
  height: 5rem;
  background: ${props => rgba(props.background, 0.6)};
  border-radius: 8.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AmountDiv = styled.div`
  font-size: 4.5rem;
  line-height: 5.4rem;
  color: ${colors.darkBlue_darker};
`;

const TitleDiv = styled.div`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_light};
`;

InfoSection.propTypes = {
  title: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  iconBackground: PropTypes.string.isRequired
};

function InfoSection({title, amount, iconName, iconColor = '', iconBackground}) {
  let displayAmount = isNaN(Number(amount)) ? amount : Number(amount).toLocaleString();

  return (
    <InfoContainer>
      <IconContainer background={iconBackground}>
        <AppIcon name={iconName} color={iconColor} />
      </IconContainer>

      <AmountDiv>{displayAmount}</AmountDiv>

      <TitleDiv>{title}</TitleDiv>
    </InfoContainer>
  );
}

export default InfoSection;
